import { render } from "./SurveyBlank.vue?vue&type=template&id=13cde730&scoped=true"
import script from "./SurveyBlank.vue?vue&type=script&lang=js"
export * from "./SurveyBlank.vue?vue&type=script&lang=js"

import "./SurveyBlank.vue?vue&type=style&index=0&id=13cde730&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cde730"]])

export default __exports__